"use client";

import React from "react";
import { TimelineEvent, TimelineVertical } from "@ama-pt/agora-design-system";
import { TimelineBlockProps } from "@/page-builder/fragments/TimelineBlock/types";
import WrapperBlueStyle from "@/components/atoms/wrapper-blue-style";
import { renderRichTextAsHTML } from "@/components/molecules/Heading";

export default function Timeline(data: TimelineBlockProps) {
  return (
    <WrapperBlueStyle>
      <div className="container py-48 mx-auto">
        <div className="flex gap-24 flex-col md:flex-row">
          <div className="w-full md:w-1/3">
            <span> {renderRichTextAsHTML(data?.title, false)} </span>
            <p className="text-m-regular mt-16 text-neutral-900">{data?.description}</p>
          </div>

          <div className="w-full md:w-2/3">
            <TimelineVertical className="py-8" hideLabels={false}>
              {data?.items.map((event, index) => (
                <TimelineEvent
                  className="!text-m-medium !text-primary-600"
                  key={index}
                  label={event.date}
                >
                  <p className="text-primary-600 text-m-bold mb-4">
                    {event.title}
                  </p>
                  <span className="text-m-regular text-neutral-900 mb-16">
                    {event.description}
                  </span>
                </TimelineEvent>
              ))}
            </TimelineVertical>
          </div>
        </div>
      </div>
    </WrapperBlueStyle>
  );
}
